module.exports = __webpack_public_path__ + "img/bronze_top_performer.4be66ce9.png";